const language: Record<string, string> = {
    e0001: "접근 권한 없음",
    e0002: "이 채널에 접근할 권한이 없습니다.",
    e0003: "페이지 없음",
    e0004: "방문하려는 페이지를 찾을 수 없습니다.\n방문하려는 주소가 정확한지 확인해주세요.",
    e0005: "오류가 발생했습니다. 잠시 후 다시 이용해 주세요.",
    e0006: "서비스 사용에 불편함을 드려 죄송합니다.\n서비스에 시스템 오류가 발생하여 페이지를 표시할 수 없습니다.",
    e0007: "데이터를 가져오지 못했습니다.",
    e0008: "",
    e0009: "오류가 발생하여 페이지를 표시할 수 없습니다.",
    e0010: "서비스 사용에 불편함을 드려 죄송합니다.\n잠시 후 다시 이용해주세요.",
    e0011: "홈으로 이동",

    b0001: "아니오",
    b0002: "네",
    b0003: "확인",
    b0004: "취소하기",

    i0000: "서비스 소개",
    i0001: "구독 플랜",
    i0002: "문서",
    i0003: "사용 가이드",
    i0004: "개발자 문서",
    i0005: "언어",
    i0006: "한국어",
    i0007: "English",
    i0008: "회원 가입",
    i0009: "로그인",
    i0010: "계정 설정",
    i0011: "채널 목록",
    i0012: "로그아웃",
    i0013: "홈페이지에 SiteBunny를\n설치하세요",
    i0014: "회사에 대한 모든 정보를 고객이 쉽게 알 수 있습니다.",
    i0015: "무료로 시작하기",
    i0016: "홈페이지는 물론 다양한 데이터소스를 업로드할 수 있습니다.",
    i0017: "홈페이지를 비롯하여 파일을 업로드하거나, Notion, Google Drive를 연결해보세요.\n" +
        "업로드된 데이터소스를 기반으로 LLM과 42maru의 RAG, 프롬프트엔지니어링 기술을 활용하여 고객에게 정확도 높은 답변을 제공합니다.",
    i0018: "*플랜별로 지원 범위는 상이할 수 있습니다.",
    i0019: "홈페이지 url을 등록하면 웹페이지와 파일 데이터를 모두 가져옵니다.",
    i0020: "PDF, Word, PPT, txt 파일을 지원합니다.",
    i0021: "여러 Notion 워크스페이스와 Google Drive를 연결할 수 있습니다.",
    i0022: "생성형 AI 기반으로 고객에게 추천 질문을 제공합니다.",
    i0023: "고객이 챗봇을 편하게 이용하고 궁금한 것을 질문할 수 있도록 도와줍니다.\n" +
        "고객의 예상 질문을 AI가 대신 고민해주어 챗봇 관리가 편리합니다.",
    i0024: "챗봇 말풍선 밑에 있는 ‘추천 질문' 버튼을 클릭해보세요.",
    i0025: "버튼을 클릭하면 즉시 추천 질문으로 챗봇과 대화가 이어집니다.",
    i0026: "특정 챗봇 메시지에 대한 추천 질문을 직접 설정할 수 있습니다.",
    i0027: "챗봇이 고정된 답변을 하길 원하시나요?",
    i0028: "고객이 특정 질문을 했을 때, 챗봇이 항상 같은 답변을 하도록 설정할 수 있습니다.\n" +
        "LLM이 생성한 답변이 아닌, 챗봇 관리자가 직접 작성한 내용대로 대답합니다.",
    i0029: "봇과 사용자의 대화를 모니터링하며 간편하게 질문과 답변을 수정해보세요.",
    i0030: "고객의 특정 질문을 챗봇이 잘 인식하기 위해 유사 메시지를 등록해보세요.",
    i0031: "봇의 답변과 함께 보여질 ‘출처 url’과 ‘추천 질문'도 작성할 수 있습니다.",
    i0032: "기업의 아이덴티티를 담아보세요.",
    i0033: "기업의 로고, 브랜드 색상을 챗봇에 적용해보세요.\n" +
        "챗봇 색상과 버튼 디자인을 자유롭게 커스터마이징할 수 있습니다.\n" +
        "버튼에는 기업 로고를 직접 등록할 수 있습니다.",
    i0034: "색상은 ‘단색'과 ‘그라데이션' 중 선택하여 적용할 수 있습니다.",
    i0035: "적용된 색상은 챗봇 전체 스타일에 반영됩니다.",
    i0036: "버튼 이미지와 함께 텍스트 문구를 넣어보세요.",
    i0037: "구독 플랜",
    i0038: "회원님에게 알맞은 플랜을 선택하세요.",
    i0039: "월간 구독",
    i0040: "연간 구독",
    // i0041: "월 {price}",
    // i0041_1: "원",
    // i0042: "연 {price}",
    // i0042_1: "원",
    i0041: "금액 미정",
    i0041_1: " ",
    i0042: "금액 미정",
    i0042_1: " ",
    i0043: "{name}으로 구독 시작",
    i0044: "서비스 이용 약관",
    i0045: "개인정보 처리 방침",
    i0046: "회사명: 42maru",
    i0047: "대표 이름: 김동환",
    i0048: "주소: 서울특별시 서초구 신반포로 310, 영화빌딩 1-7층 (06533)",
    i0049: "고객센터: 02-6952-9201",
    i0050: "이메일: www.42maru.ai",
    i0051: "2024 SiteBunny. All rights reserved",
    i0052: "아직 사용자 가이드가 준비되지 않았습니다.",
    i0053: "아직 개발자 문서가 준비되지 않았습니다.",
    i0054: "아직 서비스 이용약관이 준비되지 않았습니다.",
    i0055: "아직 개인정보 처리 방침이 준비되지 않았습니다.",
    i0056: "SiteBunny에서 회원가입하여 새 채널을 생성하려면 온보딩으로 이동합니다.\n초대받은 채널이 있으시면 '회원가입하기'를 클릭하세요.",
    i0057: "이미 채널이 있습니다.\n새 채널을 생성하고 결제하시겠습니까?",
    i0058: "네",
    i0059: "채널 목록으로",
    i0060: "새 채널 생성하기",
    i0061: "회원가입하기",
    i0062: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
    i0063: "계정 설정",
    i0064: "이메일",
    i0065: "이름",
    i0066: "저장",
    i0067: "비밀번호 변경",
    i0067_1: "계정 삭제",
    i0067_2: "정말로 계정을 삭제하시겠습니까?\n이 계정으로 생성한 모든 데이터가 함께 삭제됩니다.",
    i0067_3: "계정이 삭제되었습니다.",
    i0067_4: "계정을 삭제하는 도중 오류가 발생했습니다.",
    i0068: "이름을 입력해주세요",
    i0069: "이름을 성공적으로 변경했습니다.",
    i0070: "15자 이상 입력할 수 없습니다.",
    i0071: "이름을 변경하는 도중 오류가 발생했습니다.",
    i0072: "새 채널을 만드시겠습니까?\n온보딩으로 연결됩니다.",
    i0073: "이름을 입력해주세요.",
    i0074: "계정 삭제하기",
    i0075: "변경하기",
    i0076: "잘못된 비밀번호입니다.",
    i0077: "이전과 동일한 비밀번호를 사용할 수 없습니다.",
    i0078: "비밀번호가 성공적으로 변경되었습니다. 다시 로그인 해주세요.",
    i0079: "비밀번호를 변경하는 도중 오류가 발생했습니다.",
    i0080: "변경할 비밀번호를 입력하세요.\n비밀번호를 변경한 후 다시 로그인해주세요.",
    i0081: "기존 비밀번호",
    i0082: "새로운 비밀번호",
    i0083: "새로운 비밀번호 확인",
    i0084: "비밀번호는 8~15자이며, 최소 하나의 영문자, 숫자 및 특수기호를 포함해야 합니다.",
    i0085: "정말 로그아웃 하시겠습니까?",
    i0086: "로그아웃",
}

export default language;
